import { FC, forwardRef, LegacyRef, PropsWithChildren } from 'react';
import c from 'clsx';
import S from './Text.module.scss';

type Props = {
  variation?: 'h5' | 'h4' | 'h3' | 'h2' | 'body' | 'body-large' | 'caption' | 'body-small';
  bold?: boolean;
  thin?: boolean;
  regular?: boolean;
  hoverColor?: string;
  ref?: LegacyRef<HTMLParagraphElement>;
  color?: 'black-400' | 'black-100' | 'brand-400' | 'white-100' | 'error-400';
  onClick?: () => void;
  className?: string;
};

export const Text: FC<PropsWithChildren<Props>> = forwardRef((props, ref) => {
  const { children, variation, bold, thin, color, onClick, className, regular, hoverColor } = props;

  const classes = c(
    S.reset,
    {
      [S.h2]: variation === 'h2',
      [S.h3]: variation === 'h3',
      [S.h4]: variation === 'h4',
      [S.h5]: variation === 'h5',
      [S.regular]: regular,
      [S.bold]: bold,
      [S.bodySmall]: variation === 'body-small',
      [S.body]: variation === 'body',
      [S.bodyLarge]: variation === 'body-large',
      [S.caption]: variation === 'caption',
      [S.thin]: thin,
      [S.black400]: color === 'black-400',
      [S.black100]: color === 'black-100',
      [S.brand400]: color === 'brand-400',
      [S.white100]: color === 'white-100',
      [S.error400]: color === 'error-400',
      [S.hover]: !!hoverColor,
    },
    className
  );
  return (
    <p ref={ref} style={{ '--hover-color': hoverColor }} onClick={onClick} className={classes}>
      {children}
    </p>
  );
});

Text.displayName = 'Text';
